export const toAbsoluteUrl = (pathname: string) =>
  (process.env.NODE_ENV === 'development'
    ? process.env.PUBLIC_URL
    : process.env.REACT_APP_BUCKET_URL + '/metronic/v8') + pathname
